<template>
	<div class="top-divider">
		<v-textarea
			class="mt-4 no-line"
			label="メモ"
			outlined
			dense
			v-if="memo_data.content"
			v-model="memo_data.content"
			no-resize
			readonly
			persistent-hint
			rows="1"
			:hint="`${allFiles > 0 ? `${allFiles}件の添付ファイルがあります。` : '添付ファイルはありません。'}右のアイコンから編集・削除が可能です`"
		>
			<template v-slot:append-outer>
				<v-btn icon class="ml-2" @click="dialog = true"><v-icon>mdi-pencil</v-icon></v-btn>
				<v-btn icon class="ml-2" @click="deleteMemo"><v-icon>mdi-delete</v-icon></v-btn>
			</template></v-textarea
		>
		<v-dialog
			v-model="dialog"
			max-width="700px"
			:fullscreen="$vuetify.breakpoint.xs ? true : false"
			:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
			@click:outside="closeDialog"
		>
			<v-card :tile="$vuetify.breakpoint.xs">
				<v-app-bar dense dark flat color="primary" tag="div">
					<v-app-bar-title class="color-white">メモ登録</v-app-bar-title>
					<v-spacer />
					<v-btn icon dark @click="closeDialog" color="white">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-app-bar>

				<v-form class="pa-2" ref="form" v-model="valid">
					<MemoForm :memo_data.sync="memo" />
				</v-form>
				<p class="pa-2 text-body-2 red--text">登録ボタンを押すまで変更は反映されません。</p>
				<v-card-actions>
					<v-row no-gutters class="pb-2">
						<v-col sm="4" cols="0" />
						<v-col sm="4" cols="12">
							<v-row no-gutters justify="center">
								<v-btn color="secondary" @click="saveForm" :disabled="!valid">
									<v-icon class="mr-2">mdi-plus</v-icon>
									登録する
								</v-btn>
							</v-row>
						</v-col>
						<v-col sm="4" cols="0" v-if="!$vuetify.breakpoint.xs">
							<v-row no-gutters justify="end">
								<v-btn color="grey darken-1" text @click="closeDialog"> 閉じる </v-btn>
							</v-row>
						</v-col>
					</v-row>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import _ from "lodash"
import rules from "../../helper/rules"
import common from "../../helper/common"
import MemoForm from "./MemoForm.vue"

export default {
	props: {
		memo_data: {
			type: Object,
			required: true,
		},
	},
	components: {
		MemoForm,
	},
	data() {
		return {
			dialog: this.memo_data.id ? false : true,
			valid: false,
			rules: rules,
			memo: {
				content: null,
				files: [],
				existing_files: [],
			},
			common: common,
		}
	},
	mounted() {
		this.memo = _.cloneDeep(this.memo_data)
	},
	methods: {
		saveForm() {
			this.dialog = false
			this.$emit("change-memo", _.cloneDeep(this.memo))
		},
		deleteMemo() {
			this.$emit("delete-memo", this.memo_data)
		},
		closeDialog() {
			this.dialog = false
			if (!this.memo_data.content) {
				this.$emit("delete-memo", this.memo_data)
			}
		},
	},
	computed: {
		allFiles() {
			return this.memo.files.length + (this.memo.existing_files ? this.memo.existing_files?.length : 0)
		},
	},
}
</script>